import type { ViewMode } from '@rss/shared';

/** User-facing names of the list views, for every select and switch. */
export const VIEW_LABELS: Record<ViewMode, string> = {
  list: 'List',
  cards: 'Cards',
  magazine: 'Magazine',
};
